import { motion } from "framer-motion"
import BaseHeadline from "../../../components/general/BaseHeadline"
import BaseIcon from "../../../components/general/BaseIcon"
import { SoftwareCardType, THeading } from "../../../types/index"

type DisadvantageProps = {
    heading: THeading
    cards?: SoftwareCardType[]
}

export default function Disadvantage({ heading, cards }: DisadvantageProps) {
    const safeCards = cards ?? []

    return (
        <div className="py-32 max-w-page mx-auto px-4 md:px-8 xl:px-0">
            <motion.div
                className="text-center mb-20"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: 0.2 }}
            >
                <BaseHeadline
                    headline={heading.headline}
                    text={heading.text}
                    label={heading.label}
                    tag="h2"
                    center
                    classProps="justify-center"
                />
            </motion.div>

            <motion.div
                className="grid md:grid-cols-3 gap-8"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: 0.3, staggerChildren: 0.1 }}
            >
                {safeCards.map((card, idx) => (
                    <motion.div
                        key={`${card.title}-${idx}`}
                        className="group relative overflow-hidden bg-base-100 border border-base-300/30 rounded-2xl p-8 hover:border-primary/50 transition-colors duration-300"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.5, delay: 0.4 + idx * 0.1 }}
                    >
                      
                        {/* Icon Box */}
                        <div className="w-14 h-14 rounded-xl bg-primary/5 flex items-center justify-center mb-6 border border-primary/20 group-hover:border-primary/50 transition-colors duration-300">
                            <BaseIcon name={card.lucideIcon} color="hsl(var(--p))" size={24} />
                        </div>

                        {/* Title */}
                        <h3 className="text-xl font-semibold font-headline mb-3 text-base-content">
                            {card.title}
                        </h3>

                        {/* Description */}
                        <p className="text-base text-base-content/75 leading-relaxed">
                            {card.text}
                        </p>
                    </motion.div>
                ))}
            </motion.div>
        </div>
    )
}
